<template>
<div class="BaseFieldService">
  <div  :class="['wrapper', {'upload': type === 'upload'},{'card': type === 'card'},{'error': error}]">
    <div class="blocks" v-if="type === 'input' && inputType !== 'number'">
      <div class="input_block">
        <v-textarea
          :type="inputType"
          :placeholder="placeholder"
          :value="inputValue"
          :dense="true"
          :outlined="true"
          :disabled="readOnlyInput"
          :hide-details="true"
          :append-icon="inputAppendIcon"
          :style="`width:${inputWidth};`"
          @input="inputMainChange"

        >
          <template v-slot:append >
            <div class="input_append">
              {{inputAppendText}}
            </div>
          </template>
        </v-textarea>
      </div>
      <div class="btn-inner_block" v-if="btnInner">
        <v-btn
          large
          class="AdminPanelServices__btn"
          color="white"
          outlined
        >
          {{btnInnerTitle}}
        </v-btn>
      </div>
      <div class="actions_block">
        <span v-for="(action,idx) of actions" :key="idx" :class="{'editHidden': (!editPage && action === 'update')}">
          <v-btn icon color="primary" v-if="action === 'draggable'">
            <v-icon>mdi-arrow-all</v-icon>
          </v-btn>
          <v-btn icon color="error" v-if="action === 'delete'">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
          <v-btn
            v-if="action === 'update'"
            icon
            :color="readOnlyInput ? '': 'primary'"
            @click="createableInput()"
          >
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </span>
      </div>
    </div>
    <div class="blocks" v-if="inputType === 'number'">
      <div class="input_block">
        <v-text-field
          :type="inputType"
          :placeholder="placeholder"
          :value="inputValue"
          :dense="true"
          :outlined="true"
          :disabled="readOnlyInput"
          :hide-details="true"
          :append-icon="inputAppendIcon"
          :style="`width:${inputWidth};`"
          @input="inputMainChange"

        >
          <template v-slot:append >
            <div class="input_append">
              {{inputAppendText}}
            </div>
          </template>
        </v-text-field>
      </div>
      <div class="btn-inner_block" v-if="btnInner">
        <v-btn
          large
          class="AdminPanelServices__btn"
          color="white"
          outlined
        >
          {{btnInnerTitle}}
        </v-btn>
      </div>
      <div class="actions_block">
        <span v-for="(action,idx) of actions" :key="idx" :class="{'editHidden': (!editPage && action === 'update')}">
          <v-btn icon color="primary" v-if="action === 'draggable'">
            <v-icon>mdi-arrow-all</v-icon>
          </v-btn>
          <v-btn icon color="error" v-if="action === 'delete'">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
          <v-btn
            v-if="action === 'update'"
            icon
            :color="readOnlyInput ? '': 'primary'"
            @click="createableInput()"
          >
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </span>
      </div>
    </div>
    <div class="blocks" v-if="type === 'upload'">
      <div class="uploadBox">
        <UploadBox
          v-if="!mainImageBase64"
          :type="'service'"
          :accept-file="['jpg', 'png','webp']"
          @upload="uploadMainImage"
        />
        <div v-else class="preview">
          <div class="wrapper">
            <div class="image">
              <v-img :src="mainImageBase64" max-width="150px" max-height="150px"/>
            </div>
            <div class="actions_block">
              <span v-for="(action,idx) of actions" :key="idx">
                <v-btn icon color="primary" v-if="action === 'draggable'">
                  <v-icon>mdi-arrow-all</v-icon>
                </v-btn>
                <v-btn icon color="error" v-if="action === 'delete'" @click="deleteMainImage">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                <v-btn
                  v-if="action === 'update'"
                  icon
                  :color="readOnlyInput ? '': 'primary'"
                  @click="clearMainImage"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="blocks flex-column pa-2" v-if="type === 'uploadPreview'">
      <h2>Загрузка превью услуги</h2>
      <div class="uploadBox">
        <UploadBox
          v-if="!previewBase64 && !previewFileBase64 "
          :type="'service'"
          :accept-file="['jpg', 'png','webp','pdf', 'docx', 'doc']"
          @upload="uploadPreview"
        />
        <div v-else class="preview">
          <div class="wrapper">
            <div class="image" v-if="previewBase64">
              <v-img :src="previewBase64" max-width="150px" max-height="150px"/>
            </div>
            <div v-if="previewFileBase64">
              <a :href="previewFileBase64" class="mr-5">Открыть файл</a>
              <v-icon large color="grey" class="cursor-pointer">mdi-file</v-icon>
            </div>
            <div class="actions_block">
              <span v-for="(action,idx) of actions" :key="idx">
                <v-btn icon color="primary" v-if="action === 'draggable'">
                  <v-icon>mdi-arrow-all</v-icon>
                </v-btn>
                <v-btn icon color="error" v-if="action === 'delete'" @click="deletePreview">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                <v-btn
                  v-if="action === 'update'"
                  icon
                  :color="readOnlyInput ? '': 'primary'"
                  @click="clearPreview"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="blocks" v-if="type === 'card' && cards.length ">
      <div class="card_wrapper" v-for="card of cards" :key="card.id">
        <div class="card_upload">
          <UploadBox
            v-if="!card.imageBase64"
            :type="'service'"
            :accept-file="['jpg', 'png','webp']"
            @upload="(file)=>uploadCardImage(card,file)"
          />
          <div class="image" v-else>
            <v-img
              :src="card.imageBase64"
              :contain="true"
            />
            <div class="delete-image">
              <v-btn
                v-if="card.imageBase64"
                icon
                color="error"
                @click="deleteCardImage(card)">
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
        <div class="card_input input_block">
          <v-textarea
            no-resize
            :placeholder="placeholder"
            :dense="true"
            :outlined="true"
            :disabled="readOnlyInput"
            :hide-details="true"
            :style="`width:${inputWidth}; height: ${inputHeight}`"
            :value="card.description"
            @input="(val)=>inputDescriptionCardChange(val,card)"
          />
        </div>
      </div>
      <div class="actions_block">
        <span v-for="(action,idx) of actions" :key="idx" :class="{'editHidden': (!editPage && action === 'update')}">
          <v-btn icon color="primary" v-if="action === 'draggable'">
            <v-icon>mdi-arrow-all</v-icon>
          </v-btn>
          <v-btn icon color="error" v-if="action === 'delete'">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
          <v-btn
            v-if="action === 'update'"
            icon
            :color="readOnlyInput ? '': 'primary'"
            @click="createableInput()"
          >
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </span>
      </div>
    </div>
    <div v-if="btnSlot" class="btnDownBlocks">
      <slot name="btnDownBlock"/>
    </div>
    <slot name="errorValidate" v-if="error">
      <div class="text-error pt-1">
        {{error}}
      </div>
    </slot>
  </div>
</div>
</template>

<script>
import UploadBox from '@/components/candidates/profile/dossier/UploadBox.vue';

/**
 * Компонент: BaseFieldService
 * Описание:
 */
export default {
  name: 'BaseFieldService',

  components: { UploadBox },

  props: {
    type: {
      type: String,
      validator(value) {
        return ['input', 'upload', 'card', 'uploadPreview'].includes(value);
      },
      default: 'input'
    },
    placeholder: {
      type: String,
      default: 'Введите название блока'
    },
    actions: {
      type: Array,
      default: () => [],
    },
    widthContainer: {
      type: String,
      default: () => '100%'
    },
    inputValue: {
      type: String,
      default: () => ''
    },
    inputWidth: {
      type: String,
      default: () => '100%'
    },
    inputHeight: {
      type: String,
      default: () => '100%'
    },
    inputType: {
      type: String,
      default: () => 'text'
    },
    inputAppendText: {
      type: String,
      default: () => ''
    },
    inputAppendIcon: {
      type: String,
      default: () => ''
    },
    mainImage: {
      type: [File, Object],
      default: () => {}
    },
    mainImageBase64: {
      type: String,
      default: () => ''
    },
    preview: {
      type: [File, Object],
      default: () => {}
    },
    previewBase64: {
      type: String,
      default: () => ''
    },
    previewFile: {
      type: [File, Object],
      default: () => {}
    },
    previewFileBase64: {
      type: String,
      default: () => ''
    },
    btnInner: {
      type: Boolean,
      default: () => false,
    },
    btnInnerTitle: {
      type: String,
      default: () => ''
    },
    btnSlot: {
      type: Boolean,
      default: () => false,
    },
    cards: {
      type: Array,
      default: () => []
    },
    error: {
      type: [String],
      default: () => '',
    },
    editPage: {
      type: Boolean,
      default: () => false,
    }
  },
  emits: [
    'btnInnerClick',
    'update:mainInput',
    'update:mainImage',
    'update:cardImage',
    'update:cardDescription',
    'deleteMainImage',
    'clearMainImage',
    'update:preview',
    'deletePreview',
    'clearPreview',
  ],

  data() {
    return {
      readOnlyInput: !!this.editPage
    };
  },

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },
  methods: {
    createableInput() {
      this.readOnlyInput = !this.readOnlyInput;
    },
    inputMainChange(val) {
      this.$emit('update:mainInput', val);
    },

    uploadMainImage(image) {
      this.$emit('update:mainImage', image);
    },
    deleteMainImage() {
      this.$emit('deleteMainImage');
    },
    clearMainImage() {
      this.$emit('clearMainImage');
    },
    uploadPreview(file) {
      this.$emit('update:preview', file);
    },
    deletePreview() {
      this.$emit('deletePreview');
    },
    clearPreview() {
      this.$emit('clearPreview');
    },
    uploadCardImage(card, image) {
      this.$emit('update:cardImage', card, image);
    },
    inputDescriptionCardChange(value, card) {
      this.$emit('update:cardDescription', value, card);
    },
    deleteCardImage(card) {
      this.$emit('deleteImageCard', card);
    },
  },
};
</script>

<style scoped lang="scss">
.BaseFieldService {
  height: 100%;
  /* Стили компонента */
  & .wrapper {
    display: flex;
    flex-direction: column;
    width: fit-content;
    height: 100%;
    &:not(.upload){
      padding: 9px 4px;
      border: 1px dashed var(--color-grey-500);
      border-radius: 8px;
    }
    &.error{
      background: transparent!important;
      border: 1px dashed var(--color-error);
      &.upload{
        padding: 10px;
      }
    }

  }
  & .blocks{
    display: flex;
    flex-wrap: nowrap;
    align-items: self-start;
    gap: 16px;
    height: 100%;
    & .actions_block{
      display: flex;
      padding: 0 8px;
      gap: 8px;
      & span{
        width: 40px;
        height: 40px;
        border: 1px solid var(--color-grey-500);
        border-radius: 100%;
        &.editHidden{
          display: none;
        }
        & .v-btn{
          width: 100%;
          height: 100%;
        }
        & .v-icon{
          font-size: 25px;
        }
      }
    }
    & .input_block{
      ::v-deep .v-input__control {
        height: 100%;
      }
      ::v-deep .v-input__slot {
        background: white;
        height: 100%;
      }
      ::v-deep .v-text-field__slot {
        padding: 4px ;
        align-items: self-start;
        & textarea{
          height: 60px;
        }
      }

    }
    & .btn-inner_block{
      & .v-btn{
        background: var(--color-blue-500);
        border-radius: 6px;
        height: 100%;
        font-size: 16px;
        padding: 9px 16px;
        margin-left: 8px;
        ::v-deep span{
          line-height: 24px;
        }
      }

    }
    & .uploadBox{
      height: 100%;
      & .upload-box{
        height: 100%;
        border: 1.5px dashed var(--color-grey-500);
        padding: 9px;
        margin: 0px;
      }
      & .preview{
        height: 100%;
        & .wrapper{
          background: white;
          flex-direction: row;
          padding: 16px 9px;
          border: 1.5px dashed var(--color-grey-500);
          border-radius: 8px;
          height: 100%;
        }
      }
    }
    & .card_wrapper{
      width: 100%;
      max-width: 248px;
      & .card_upload{
        & .image {
          position: relative;
          max-width: 248px;
          max-height: 200px;
          margin-bottom: 20px;
          & .v-image{
            max-height: 200px;
          }
          & .delete-image{
            position: absolute;
            top: 15px;
            right: 15px;
          }
        }

      }
    }
  }

  & .btnDownBlocks{
    display: flex;
    flex-wrap: nowrap;
    padding-top: 16px;
    gap: 16px;
    & .v-btn{
      background: var(--color-blue-500);
      border-radius: 6px;
      height: 100%;
      font-size: 16px;
      padding: 10px 16px;
      ::v-deep span{
        line-height: 24px;
      }
      &.background_transparent{
        background: transparent;
        color: var(--color-blue-500)!important;
      }
    }
  }

}
</style>
